import { get } from 'lodash'

import userTypes from '../user/types'
import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  unreadMessageCount: 0,
}

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case userTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        unreadMessageCount: get(action.payload, 'UnreadOutreachMessageCount', 0),
      }
    case types.UPDATE_OUTREACH_MESSAGE_COUNT:
      return {
        ...state,
        unreadMessageCount: action.payload,
      }
    default:
      return state
  }
}
